/* eslint-disable max-len */
import React from 'react'

export default function TextArea({
    label,
    placeholder,
    htmlFor,
    id,
    value,
    emptyField,
    handleOnChangeInput,
    maxLength,
    isLoading,
    PatientNotes,
}) {
    return (
        <>
            <div className='flex flex-col h-full'>
                <label htmlFor={htmlFor} className='text-xs font-semibold text-[#000] pb-1.5'>{label}</label>
                {/* border-[#D3454D] */}
                <div className={`border ${emptyField?'border-[#C81720]':'border-[#C5C9DA]'} ${PatientNotes?'border-transparent overflow-auto overflow-x-hidden scrollbar_grayw6 h-customh15 ':'border-[#C5C9DA]  h-full'} rounded-lg pr-1 py-1.5 bg-white `} >
                    <textarea type="text" id={id} 
                       onChange={(e) => {handleOnChangeInput(id,e.target.value)}}
                        value={value}
                        maxLength={maxLength}
                        className={`pl-3.5 pr-1 py-[5px] ${PatientNotes? "text-base h-[98%]" : "text-sm h-[98%]"} font-normal  text-[#000B17] w-full  ${PatientNotes? "placeholder:text-[#A0A0A0] ":"placeholder:text-[#52555D] overflow-auto scrollbar_grayw6"} outline-none resize-none  rounded-lg`}
                        placeholder={placeholder}  >
                    </textarea>
                </div>
            </div> 
        </>
    )
}
